export default __webpack_public_path__ + "static/media/moveis.94d12097.jpg";